var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('lbls',[_vm._v("ROUTE wrapper @/src/views/admin/Index.vue")]),(_vm.$prms(['director','admin']))?_c('AdminPanel'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }